import React from "react";
import "../../css/Process_New.css";
import { motion } from "framer-motion";
import { HiOutlineLightningBolt, HiOutlineShieldCheck, HiOutlineCash } from "react-icons/hi";

export const Process_New = () => {
  const steps = [
    {
      id: "01",
      icon: <HiOutlineLightningBolt />,
      title: "Quick Loan",
      desc: "Apply in minutes with our streamlined, 100% paperless digital application. No physical paperwork required."
    },
    {
      id: "02",
      icon: <HiOutlineShieldCheck />,
      title: "Fast Approval",
      desc: "Experience AI-driven credit assessment for instant loan approval decisions with maximum security."
    },
    {
      id: "03",
      icon: <HiOutlineCash />,
      title: "Direct Fund Transfer",
      desc: "Once approved, capital is deployed directly to your designated bank account almost instantly."
    }
  ];

  return (
    <section className="process_v4_wrapper">
      <div className="process_v4_container">

        {/* Left Side: Sticky Header & Graphic Image */}
        <div className="process_v4_left">
          <div className="process_v4_sticky">
            <motion.span
              className="p_v4_badge"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              Workflow / Precision
            </motion.span>
            <motion.h2
              className="process_v4_h2"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              How We <br /><span className="text_gradient">Work.</span>
            </motion.h2>
            <motion.p
              className="process_v4_desc"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
            >
              Our proprietary lending protocol is designed to eliminate friction. Get funded in three simple, highly-secured steps.
            </motion.p>

            {/* Premium 3D Graphic Image */}
            <motion.div
              className="v4_graphic_container"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <div className="v4_graphic_glow"></div>
              <motion.img
                src={process.env.PUBLIC_URL + "/images/loan_process_graphic_rupee.png"}
                alt="Loan Process 3D Rupee"
                className="v4_3d_graphic"
                loading="lazy"
                animate={{ y: [0, -15, 0] }}
                transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
              />
            </motion.div>
          </div>
        </div>

        {/* Right Side: Step Cards */}
        <div className="process_v4_right">
          <div className="v4_timeline_line"></div>
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="v4_step_card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.02, x: -10 }}
            >
              <div className="v4_step_number">{step.id}</div>
              <div className="v4_step_icon_box">
                {step.icon}
                <motion.div className="v4_icon_glow" animate={{ opacity: [0.4, 0.8, 0.4] }} transition={{ duration: 2, repeat: Infinity }} />
              </div>
              <div className="v4_step_content">
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};
